import { EColors } from '../types/enums/EColors';

export const themeColors = {
  primary: EColors.LushBlue,
  secondary: EColors.White,
  background: EColors.PaleGrey,
  headerRow: EColors.BluishGrey,
  danger: EColors.LushRed,
  warning: EColors.YellowOrange,
  inactive: EColors.Silver,
  success: EColors.Green,
  selected: EColors.RaspberryRed,
  selectedBg: EColors.PaleRed,
  borders: EColors.BorderColor,
  innerBackground: EColors.LightGrey,
  hoverListItem: EColors.Yellowish,
  iconPrimary: EColors.Silver,
  textPrimary: EColors.Black,
  textSecondary: EColors.White,
  textComplimentary: EColors.YetAnotherGrey,
  tabBarBg: EColors.Black,
  buttonPrimary: EColors.RaspberryRed,
  buttonSecondary: EColors.Silver,
  funnel: {
    downloads: EColors.LushBlue,
    loggedIn: EColors.LightBlue,
    withESim: EColors.YellowOrange,
    activeESimProfile: EColors.RaspberryRed,
  },
};
